import { Constants } from "config/constants";

const caseStatuses = {
  "case-1": ["DRAFT", Constants.COMPANY_REVIEW_STATUSES.DRAFT],
  "case-2": ["DIRECTOR-APPROVAL", "SHAREHOLDER-APPROVAL"],
  "case-3": [
    "REGISTRAR-REVIEW",
    Constants.COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW,
    "REGISTRAR-CORRECTION",
    "REGISTRAR-REVIEW-II",
    Constants.COMPANY_REVIEW_STATUSES.REGISTRAR_REVIEW_II,
    "REGISTRAR-APPROVAL",
    Constants.COMPANY_REVIEW_STATUSES.REGISTRAR_APPROVAL,
    "LEGAL-REVIEW",
    "LEGAL-CORRECTION",
    "LEGAL-REVIEW-II",
    "LEGAL-APPROVAL",
    "LEGAL-REVIEW-II-APPROVAL",
    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.CHANGES_SIGNATURE,
  ],
  "case-4": [
    "DIRECTOR-REVIEW",
    "DIRECTOR-REVIEW-II",
    "DIRECTOR-REVIEW-CORRECTIONS",
    "DIRECTOR-REVIEW-APPROVAL",
    "DIRECTOR-REVIEW-II-APPROVAL",
    "SHAREHOLDER-REVIEW",
    "SHAREHOLDER-REVIEW-II",
    "SHAREHOLDER-REVIEW-CORRECTIONS",
    "SHAREHOLDER-REVIEW-APPROVAL",
    "SHAREHOLDER-REVIEW-II-APPROVAL",
    "ADMIN-REVIEW",
    Constants.COMPANY_REVIEW_STATUSES.ADMIN_REVIEW,
    "ADMIN-REVIEW-APPROVAL",
    Constants.COMPANY_REVIEW_STATUSES.ADMIN_CORRECTIONS,
    "ADMIN-CORRECTIONS",
    "ADMIN-REVIEW-II",
    Constants.COMPANY_REVIEW_STATUSES.ADMIN_REVIEW_II,
    "ADMIN-REVIEW-II-APPROVAL",
    "BRS-REVIEW",
    Constants.COMPANY_REVIEW_STATUSES.BRS_REVIEW,
    "BRS-REVIEW-CORRECTION",
    "BRS-REVIEW-II",
    Constants.COMPANY_REVIEW_STATUSES.BRS_REVIEW_II,
    "BRS-REVIEW-APPROVAL",
    "BRS-REVIEW-II-APPROVAL",
    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DIRECTOR_SIGNATURE,
    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.BRS_FORM_SIGNATURE,
    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_REVIEW,
    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_CS_APPROVAL,
    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_REVIEW,
    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.REGISTRAR_DR_APPROVAL,
  ],
  "case-5": [Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.AWAITING_COURT_ORDER],
  "case-6": [Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.INTENDED_DISSOLUTION],
  "case-7": [Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.DISSOLUTION_NOTICE],
  "case-8": [
    Constants.MAINTAIN_COMPANY_REVIEW_STATUSES.PENDING_REGISTRAR_DECISION,
  ],
};

const caseActions = {
  "case-1": ["view", "edit", "delete"],
  "case-2": ["view", "recall", "review", "approve"],
  "case-3": ["view", "recall", "signature", "review", "approve"],
  "case-4": ["view", "recall", "signature", "review", "approve"],
  "case-5": ["courtOrder"],
  "case-6": ["intendedDissolution"],
  "case-7": ["dissolutionNotice"],
  "case-8": ["pendingRegistrarDecision"],
};

const findCaseForStatus = (status) => {
  for (const [caseKey, statuses] of Object.entries(caseStatuses)) {
    if (statuses.includes(status)) {
      return caseKey;
    }
  }
  return null;
};

export const getActionsForStatus = (status) => {
  const caseKey = findCaseForStatus(status);
  if (caseKey) {
    return caseActions[caseKey];
  }
  return [];
};
